import React, { useEffect, useState } from "react";
import Moment from "react-moment";

const Countdown: React.FC<{
  time?: number;
  setTime?: (time: number) => void;
  cb?: () => void;
}> = ({ cb, setTime, time }) => {
  const [remainingTime, setRemainingTime] = useState<number>(time || 30);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    const updateCountdown = () => {
      if (remainingTime && remainingTime > 0) {
        setRemainingTime((prevTime) => prevTime - 1);
      } else {
        clearInterval(timer!);
        setTime && setTime(0);
        cb && cb();
      }
    };

    timer = setInterval(updateCountdown, 1000);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [cb, remainingTime, setTime]);

  if (typeof remainingTime === "undefined") {
    return null;
  }

  return (
    <div>
      <Moment format="ss" unix style={{ marginLeft: "5px" }}>
        {remainingTime}
      </Moment>
      s
    </div>
  );
};

export default Countdown;
